<template>
  <v-card class="mr-3 ml-3 mb-3">
    <v-card>
        <v-card-text>
          <!-- <v-col cols="3" style="padding-left: 0px !important">
            <v-card min-height="200" class="mx-2">

            </v-card>
          </v-col> -->
          <v-row>
            <v-col cols="12">
              <v-card class="mx-2">
                <v-card-text>
                  <v-row>
                    <v-col cols="2" style="display: flex; align-items: center;">
                      <span class="headline">Период</span>
                    </v-col>
                    <v-col cols="10">
                      <MonthPicker v-model="datePickerValues"></MonthPicker>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="2" style="display: flex; align-items: center;">
                      <span class="headline">Модули ПО</span>
                    </v-col>
                    <v-col cols="10" style="padding-left: 0px; padding-right: 0px;">
                      <ModuleSelector v-model="selectedModules" :multiSelect="true" style="width: 100%; padding: 0 25px 0 0; margin: 0;" class="mx-3"/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="2" style="display: flex; align-items: center;">
                      <span class="headline">Дилеры</span>
                    </v-col>
                    <v-col cols="10" style="padding-left: 0px; padding-right: 0px;">
                      <DealerSelector v-model="selectedDealers" :multiSelect="true" style="width: 100%; padding: 0 25px 0 0; margin: 0;" class="mx-3"/>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
            <v-menu v-if="this.$store.getters.user.roleId === 0" class="mr-3" color="green" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" :loading="fileLoading">
                <v-icon>mdi-file-download</v-icon>
                Выгрузить в файл
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="exportToFile('csv')">csv</v-list-item>
              <v-list-item @click="exportToFile('xlsx')">xlsx</v-list-item>
            </v-list>
          </v-menu>
          <v-spacer></v-spacer>
            <v-btn color="primary darken-1" text @click="getMasters"
                      >Применить</v-btn
                    >
        </v-card-actions>
      </v-card>
      <ColumnChart v-if="showChart" :names="chartNames" :series="chartSeries" style="margin-top: 15px;"></ColumnChart>
      <v-card-title class="headline justify-space-between">
        <v-spacer></v-spacer>
        <div>
          <v-text-field
          v-if="$store.getters.dealers"
          v-model="search"
          append-icon="mdi-magnify"
          label="Поиск"
          single-line
          hide-details
          class="pt-0"
          ></v-text-field>
        </div>
      </v-card-title>
    <v-data-table
      class="mb-3 mx-3"
      :search="search"
      :headers="headers"
      :items="objectsFiltered"
      :item-class="() => 'clickable-row'"
      sort-by="expires"
      no-data-text="Пусто"
      no-results-text="Результатов нет"
      hide-default-footer
      :custom-sort="customSort"
      @click:row="editMaster"
      :loading="tableLoading"
      loading-text="Загрузка"
      :items-per-page="10"
    >
      <template v-slot:item.expires="{ item }">
        <v-badge v-if="item.sos" content="SOS" color="error">
          {{ new Date(item.expires).toLocaleDateString() }}
        </v-badge>
        <span v-else>
          {{ new Date(item.expires).toLocaleDateString() }}
        </span>
      </template>
      <template v-slot:item.objectName="{ item }">
        <span
          class="clickable-item"
          @click.stop="$router.push(`/objects/${item.objectId}`)"
          >{{ item.objectName }}</span
        >
      </template>
      <template v-slot:item.dealerName="{ item }">
        <span
          class="clickable-item"
          @click.stop="$router.push(`/dealers/${item.dealerId}`)"
          >{{ item.dealerName }}</span
        >
      </template>
      <!-- <template v-slot:item.expires="{ item }">
        <span :class="{ expired: new Date() > new Date(item.expires) }">
          <v-badge v-if="item.isSosActivated" color="red" content="SOS">{{
            new Date(item.expires).toLocaleDateString()
          }}</v-badge>
          <template v-else>{{
            new Date(item.expires).toLocaleDateString()
          }}</template>
        </span>
      </template> -->
      <template v-slot:item.moneyFor="{ item }">
          <span v-if="item.showroom">Никому, это шоурум</span>
          <span v-else-if="item.moneyFor != null && $store.getters.mappedOurLegalEntities[item.moneyFor]">{{
            $store.getters.mappedOurLegalEntities[item.moneyFor].name }}</span>
          <span v-else>Не задано</span>
      </template>
      <template v-slot:top="{ pagination, options, updateOptions }">
        <v-data-footer
          :pagination="pagination"
          :options="options"
          @update:options="updateOptions"
          :items-per-page-options="[10, 50, 100, -1]"
          items-per-page-text="$vuetify.dataTable.itemsPerPageText"
        />
      </template>
      <template v-slot:item.updateTime="{ item }">
        <span>{{ formatUpdateTime(item.updateTime) }}</span>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import API from "@/axios/api";
import FormatDateTime from "@/utils/time.js";
import MonthPicker from "./MonthPicker.vue";
import ModuleSelector from "./ModuleSelector.vue";
import DealerSelector from "./DealerSelector.vue";
import ColumnChart from "./ColumnChart.vue";

export default {
  data() {
    return {
      fileLoading: false,
      page: 1,
      pageCount: 0,

      periodDialog: false,

      dateFromMenu: false,
      dateFrom: null,
      dateFromFormatted: "",

      dateToFormatted: "",
      dateTo: null,
      dateToMenu: false,

      entity_list: [],
      money_for_filter: [],

      tableLoading: true,
      search: "",
      logs: [],
      objectsFiltered: [],
      headers: [
        {
          text: "ID",
          align: "start",
          value: "licenseId",
          sortable: false,
        },
        {
          text: "Дата создания",
          align: "start",
          value: "dateStr",
          sortable: false,
        },
        {
          text: "Дата окончания",
          align: "start",
          value: "expires",
          sortable: true,
        },
        {
          text: "Срок жизни (мес)",
          align: "start",
          value: "activeTimeMonths",
          sortable: false,
        },
        {
          text: "Модуль ПО",
          align: "start",
          value: "productName",
          sortable: false,
        },
        {
          text: "Фичи",
          align: "start",
          value: "features",
          sortable: false,
        },
        {
          text: "Количество",
          align: "start",
          value: "mastersCount",
          sortable: false,
        },
        {
          text: "Объект",
          align: "start",
          value: "objectName",
          sortable: false,
        },
        {
          text: "Дилер",
          align: "start",
          value: "dealerName",
          sortable: false,
        },
        // {
        //   text: "Деньги кому?",
        //   align: "start",
        //   value: "moneyFor",
        //   sortable: false,
        // },
        // {
        //   text: "Max Date",
        //   align: "center",
        //   value: "expires",
        // },
        // {
        //   text: "Изменил",
        //   align: "center",
        //   value: "creatorName",
        // },
        // {
        //   text: "Дата последнего изменения",
        //   align: "start",
        //   value: "updateTime",
        // },
      ],
      datePickerValues: null,
      selectedModules: null,
      selectedDealers: null,
      chartNames: [],
      chartSeries: [],
      showChart: false,

    };
  },
  watch: {
    dateFrom() {
      this.dateFromFormatted = this.formatDate(this.dateFrom);
    },
    dateTo() {
      this.dateToFormatted = this.formatDate(this.dateTo);
    },
    dateFromFormatted() {
      this.dateFrom = this.parseDate(this.dateFromFormatted);
    },
    dateToFormatted() {
      this.dateTo = this.parseDate(this.dateToFormatted);
    },
  },
  methods: {
    exportToFile(format) {
      this.fileLoading = true;
      let from = this.datePickerValues[0];
      let to = this.datePickerValues[1];
      let queryStr = `date_from=${from}&date_to=${to}`
      for (let index = 0; index < this.selectedModules.length; index++) {
        const moduleId = this.selectedModules[index];
        queryStr = queryStr + '&soft=' + moduleId
      }
      for (let index = 0; index < this.selectedDealers.length; index++) {
        const dealerId = this.selectedDealers[index];
        queryStr = queryStr + '&dealer=' + dealerId
      }
      API.get(`reports/outflow/records?${queryStr}&export=${format}`, { responseType: 'blob' })
        .then(response => {
        if (response.status === 200) {
          let contentType = '';
          let fileExtension = '';
          if (format === 'csv') {
            contentType = 'text/csv';
            fileExtension = '.csv';
          } else if (format === 'xlsx') {
            contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            fileExtension = '.xlsx';
          }
          const blob = new Blob([response.data], { type: contentType });
          const date = new Date();
          const currentDate = this.formatUpdateTime(date);
          const filename = `Отчет Отток Лицензий ${currentDate}${fileExtension}`.replace(/:/g, '.');
          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
          } else {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
          }
          this.fileLoading = false;
          console.log('Файл успешно загружен');
        } else {
          console.error('Ошибка загрузки файла:', response.statusText);
        }
      })
      .catch(error => {
        console.error('Ошибка загрузки файла:', error);
      });
    },
    customSort(items, index, isDesc) {
      if (index[0] === "expires") {
        items.sort((a, b) => {
          if (!isDesc[0]) {
            return new Date(a.expires) > new Date(b.expires) ? 1 : -1;
          } else {
            return new Date(a.expires) > new Date(b.expires) ? -1 : 1;
          }
        });
      } else {
        items.sort((a, b) => {
          if (!isDesc[0]) {
            return a[index[0]] > b[index[0]] ? 1 : -1;
          } else {
            return a[index[0]] > b[index[0]] ? -1 : 1;
          }
        });
      }
      return items;
    },
    editMaster(master) {
      this.$router.push("/masters/" + master.licenseId);
    },
    filterRecords() {
      this.objectsFiltered = this.data.data.map((v) => {
        return {
          ...v,
          // id: v.licenseId
        };
      });
    },
    async getMasters() {
      this.showChart = false;
      this.chartNames = []
      this.chartSeries = []
      if (!this.datePickerValues) {
        this.$store.commit('showSnackbar', {
          color: 'error',
          text: 'Выберите период отчёта',
        });
        return;
      }
      if (this.selectedModules.length == 0) {
        this.$store.commit('showSnackbar', {
          color: 'error',
          text: 'Выберите модули',
        });
        return;
      }
      if (this.selectedDealers.length == 0) {
        this.$store.commit('showSnackbar', {
          color: 'error',
          text: 'Выберите дилеров',
        });
        return;
      }
      let from = this.datePickerValues[0];
      let to = this.datePickerValues[1];
      this.tableLoading = true;
      let queryStr = `date_from=${from}&date_to=${to}`
      for (let index = 0; index < this.selectedModules.length; index++) {
        const moduleId = this.selectedModules[index];
        queryStr = queryStr + '&soft=' + moduleId
      }
      for (let index = 0; index < this.selectedDealers.length; index++) {
        const dealerId = this.selectedDealers[index];
        queryStr = queryStr + '&dealer=' + dealerId
      }
      await API.get(`reports/outflow/records?${queryStr}`)
        .then((response) => {
          this.data = response.data;
          this.filterRecords();
        })
        .catch((error) => {
          console.log(error);
        });
      this.tableLoading = false;

      this.setChartData()
      this.showChart = true;
    },
    formatUpdateTime(time) {
      return FormatDateTime(time);
    },
    setChartData() {
      this.showChart = false;

      let chartData = {}

      for (let index = 0; index < this.data.data.length; index++) {
        const element = this.data.data[index];
        chartData[element.expires.slice(0,7)] = (chartData[element.expires.slice(0,7)] || 0) + element.mastersCount;
      }
      chartData = Object.fromEntries(
          Object.entries(chartData).sort()
      );

      this.chartNames = Object.keys(chartData);
      this.chartSeries = [{
        name: 'Количество лицензий',
        data: Object.values(chartData)
      }]
      this.showChart = true;
    }
  },
  activated() {
    this.$store.commit("setCrumbs", [
      { text: "main", disabled: false, to: "/", exact: true },
      { text: "reports", disabled: true },
      { text: "outflow", disabled: true },
    ]);
  },
  async mounted() {
    this.tableLoading = false;
    this.$store.dispatch('updateModules');
    this.$store.dispatch('updateDealers');
  },
  created() {
  },
  components: {
    // LineChart,
    MonthPicker,
    ModuleSelector,
    DealerSelector,
    ColumnChart,
  }
};
</script>

<style>
.clickable-item {
  background-color: #d5e9d4;
  padding: 0.2rem 0.5rem;
  border-radius: 5px;
  cursor: pointer;
}

.expired {
  background-color: #eccdcd;
  color: #000000;
  padding: 0.2rem 0.5rem;
  border-radius: 3px;
}
</style>
